import React from 'react';

class FeatureErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[${this.props.name || 'Feature'}] Error:`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h4>Une erreur est survenue</h4>
          <p style={{ color: '#6c757d' }}>{this.props.name || 'Ce module'} a rencontre un probleme.</p>
          <button onClick={this.handleRetry} className="btn btn-outline-primary btn-sm">
            Reessayer
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default FeatureErrorBoundary;
